// export const BACKEND_ADDR = '192.168.2.237:8000';
export const BACKEND_ADDR = '3659-89-251-97-210.ngrok-free.app';

export const BACKEND_URL = 'https://' + BACKEND_ADDR;
export const API_URL = 'https://' + BACKEND_ADDR + '/api';
export const WS_URL = 'wss://' + BACKEND_ADDR + '/ws';

// export const BACKEND_URL = 'http://' + BACKEND_ADDR;
// export const API_URL = 'http://' + BACKEND_ADDR + '/api';
// export const WS_URL = 'ws://' + BACKEND_ADDR + '/ws';
